const StepIndicator = ({ steps, currentStep }) => (
    <ul className="flex items-center justify-center mb-5 flex-wrap gap-y-2">
        {steps.map((step, index) => {
            const isActive = step.id === currentStep;
            const isLast = index === steps.length - 1;

            return (
                <li
                    key={step.id}
                    className={`flex flex-row items-center gap-2 ${isLast ? "" : "after:content-['>'] after:pe-2"}`}
                >
                    <span
                        className={`text-center text-white rounded leading-8 w-8 h-8 ${
                            isActive ? "bg-nt-blue" : "bg-nt-grey"
                        }`}
                    >
                        {index + 1}
                    </span>
                    <label className={`text-nt-blue ${isActive ? "block" : "hidden"} lg:block`}>
                        {step.label}
                    </label>
                </li>
            );
        })}
    </ul>
);

export { StepIndicator };
